import { SiteListActionType, SiteListContext } from '@core/context';
import { FilterType, SearchType, SortColumnType, SortOrderType } from '@shared/models';
import { isNil } from 'lodash';
import { useCallback, useContext } from 'react';

export const useSiteListState = () => {
  const { state: siteListState, dispatch: siteListDispatch } = useContext(SiteListContext);

  const setSearchFilter = useCallback(
    (payload: string) => {
      siteListDispatch({ type: SiteListActionType.SetSearch, payload });
    },
    [siteListDispatch]
  );

  const setSearchFilterType = useCallback(
    (payload: SearchType) => {
      siteListDispatch({ type: SiteListActionType.SetSearchType, payload });
    },
    [siteListDispatch]
  );

  const setSiteFilter = useCallback(
    (payload: FilterType) => {
      siteListDispatch({ type: SiteListActionType.SetFilter, payload });
    },
    [siteListDispatch]
  );

  const setSortOrder = useCallback(
    (payload: SortOrderType) => {
      siteListDispatch({ type: SiteListActionType.SetSortOrder, payload });
    },
    [siteListDispatch]
  );

  const setColumnSort = useCallback(
    (payload: SortColumnType) => {
      siteListDispatch({ type: SiteListActionType.SetColumnSort, payload });
    },
    [siteListDispatch]
  );

  const setZoneFilter = useCallback(
    (payload: string) => {
      siteListDispatch({ type: SiteListActionType.SetZone, payload });
    },
    [siteListDispatch]
  );

  const setZoneOptions = useCallback(
    (payload: string[]) => {
      if (payload) {
        siteListDispatch({ type: SiteListActionType.SetZoneOptions, payload });
      }
    },
    [siteListDispatch]
  );

  const setPreferencesValuesSet = useCallback(
    (payload: boolean) => {
      if (!isNil(payload)) {
        siteListDispatch({ type: SiteListActionType.SetPreferencesValuesSet, payload });
      }
    },
    [siteListDispatch]
  );

  return {
    siteListState,
    setSearchFilter,
    setSearchFilterType,
    setSiteFilter,
    setSortOrder,
    setColumnSort,
    setZoneFilter,
    setZoneOptions,
    setPreferencesValuesSet,
  };
};
